var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#0865FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.09243 23.6453V15.6849H6.62891V11.9942H9.09243V10.3729C9.09243 8.81658 9.39298 7.08291 10.5149 5.91506C11.7598 4.61922 14.2484 4.04904 17.5834 4.74085V8.06879C15.7945 7.96371 14.8588 8.04877 14.2484 8.49911C13.6151 8.96626 13.466 9.75504 13.466 10.4029V11.9942H17.3911L16.7084 15.6849H13.466V23.9114C12.9855 23.9699 12.4963 24 12 24C10.9973 24 10.0234 23.877 9.09243 23.6453Z",
    fill: "white"
  })));
};
export default SvgFacebook;